import React, { useState, createContext, useContext } from 'react';
interface CartContextType {
  count: number;
  addToCart: () => void;
}
const CartContext = createContext<CartContextType>({
  count: 0,
  addToCart: () => {}
});
export const useCart = () => useContext(CartContext);
export const CartProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [count, setCount] = useState(2);
  const addToCart = () => setCount(c => c + 1);
  return <CartContext.Provider value={{
    count,
    addToCart
  }} data-id="element-16">
      {children}
    </CartContext.Provider>;
};